import { atom } from 'jotai';
import type { Packager, PackagePreviewResponse } from '../types/packager-types';

export const showPackagerConfigAtom = atom(false);
export const packagerIdForDocumentsModalAtom = atom<string | null>(null);
// Completeness detail modal: the chip click sets the package id to open the modal.
export const completenessModalPackageIdAtom = atom<string | null>(null);
// Drill-down into the entries modal in filtered mode. `params` is the API's
// drill-down dict (forwarded verbatim); `label` feeds the "Filtered: …" chip.
export const packageEntriesDrilldownAtom = atom<{
  packageId: string;
  params: Record<string, string>;
  label: string;
} | null>(null);
export const showPackagerCoCReportAtom = atom(false);
export const packageEditDialogPackageIdAtom = atom<string | null>(null);
export const packagerFormDirtyAtom = atom(false);
export const packagerDraftDirtyAtom = atom(false);
export const packagerSimulateModeAtom = atom(false);
export const packagerDraftChangesAtom = atom<Partial<Packager>>({});
export const packagePreviewOpenAtom = atom(false);
export const packagePreviewDataAtom = atom<PackagePreviewResponse | null>(null);
export const packagePreviewIdsAtom = atom<{ packagerId?: string; packageId?: string } | null>(null);
// Until this time (ms epoch) the packages list keeps polling: create-from-package
// builds the new package in a background task, so it appears some time later.
export const packagesRefreshUntilAtom = atom(0);
